import { State } from './store';

export const _DEFAULTS: State = {
  error: null,
};

export const DEFAULTS = (): State => {
  return JSON.parse(JSON.stringify(_DEFAULTS));
};
